/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react';

import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import {
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';

import RequiredField from 'components/common/components/RequiredField';
import { endAdornmentProps, formStyles } from 'consts/styles/Form';
import { LOCAL_ZONES_TYPES } from 'consts/config';
import ButtonsUseStyles from 'consts/styles/Buttons';

const ZoneDetailsForm = props => {
  const { values, errors, handleChange, save, borderValues } = props;
  const strings = useSelector(state => state.language).areas.add;
  const zonesCategories = useSelector(state => state.zonesCategories);
  const [switchIsActiveChecked, setSwitchIsActiveChecked] = React.useState(
    false
  );

  React.useEffect(
    () => setSwitchIsActiveChecked(!values.elevation_type === 'srtm'),
    [values]
  );

  const formClasses = formStyles();
  const classesButtons = ButtonsUseStyles();

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const { placeholderForm } = useString().areas;

  const handleSwitchIsActiveChange = () => {
    if (values) {
      values.elevation_type = switchIsActiveChecked ? 'srtm' : 'nmt';
    }
    setSwitchIsActiveChecked(!switchIsActiveChecked);
  };

  const helperTextForm = type => {
    if (type === 'othername')
      return `${placeholderForm.required +
        placeholderForm.text +
        placeholderForm.nameExsits_}.`;

    if (type === 'text') return placeholderForm.required + placeholderForm.text;
    if (type === 'desc')
      return placeholderForm.required + placeholderForm.description;
    if (type === 'number')
      return placeholderForm.required + placeholderForm.number;
    if (type === 'phone')
      return placeholderForm.required + placeholderForm.phone;
    return placeholderForm.required;
  };

  return (
    <Grid
      container
      spacing={2}
      className={`${formClasses.Form}--padding-left-right`}
    >
      <Grid item xs={12}>
        <label
          className={clsx(`${formClasses.Form}__label`, {
            [`${formClasses.Form}__text-field__form-helper--error`]: errors.othername,
          })}
          htmlFor="othername"
        >
          {strings.formFields.name_} *
        </label>
        <TextField
          inputProps={{
            placeholder: strings.formFields.name_ + placeholderForm.text,
            pattern: '[a-zA-Z]{3,50}',
            maxLength: 50,
          }}
          autoComplete="name"
          error={errors.othername}
          name="othername"
          variant="outlined"
          required
          fullWidth
          id="othername"
          autoFocus
          onChange={handleChange}
          value={values.othername}
          helperText={errors.othername && helperTextForm('othername')}
          size="small"
          InputProps={{
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          FormHelperTextProps={{
            classes: {
              error: `${formClasses.Form}__text-field__form-helper--error`,
            },
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl component="fieldset" error={errors.zone_category}>
          <InputLabel
            className={clsx(
              `${formClasses.Form}__label ${formClasses.Form}__label--select`,
              {
                [`${formClasses.Form}__text-field__form-helper--error`]: errors.zone_category,
              }
            )}
            id="user-language-label"
          >
            {strings.formFields.zoneCategory_}
          </InputLabel>
          <Select
            className={`${formClasses.Form}__select`}
            labelId="user-language-label"
            id="user-language"
            name="zone_category"
            value={values.zone_category?.uid || values?.zone_category}
            classes={{
              root: `${formClasses.Form}__text-field`,
              icon: `${formClasses.Form}__text-field`,
            }}
            MenuProps={{
              className: `${formClasses.Form}__select__menu`,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              MenuListProps: {
                className: `${formClasses.Form}__select__menu__item`,
              },
              classes: {
                list: `${formClasses.Form}__select__menu--background-color`,
              },
              getContentAnchorEl: null,
              style: { zIndex: 9999 }
            }}
            onChange={handleChange}
          >
            {zonesCategories.map(c => (
              <MenuItem key={c.uid} value={c.uid}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl error={errors.type} component="fieldset">
          <label
            className={clsx(`${formClasses.Form}__label`, {
              [`${formClasses.Form}__text-field__form-helper--error`]: errors.type,
            })}
            htmlFor="type"
          >
            {strings.formFields.zoneType_} *
          </label>{' '}
          <RadioGroup
            aria-label="type"
            name="type"
            value={values.type}
            onChange={handleChange}
            className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--width`}
          >
            <Grid container>
              {Object.keys(LOCAL_ZONES_TYPES).map(type => (
                <Grid key={type} item xs={4}>
                  <FormControlLabel
                    value={type}
                    control={
                      <Radio className={`${formClasses.Form}__switch`} />
                    }
                    label={type}
                  />
                </Grid>
              ))}
            </Grid>
          </RadioGroup>
          {errors.type && <FormHelperText>{helperTextForm('')}</FormHelperText>}
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={4}>
        <label
          className={clsx(`${formClasses.Form}__label`, {
            [`${formClasses.Form}__text-field__form-helper--error`]: errors.amsl_min,
          })}
          htmlFor="amsl_min"
        >
          {strings.formFields.min_} *
        </label>
        <TextField
          variant="outlined"
          inputProps={{
            placeholder: `${strings.formFields.min_}, min. ${borderValues.minHeight}`,
            max: borderValues.maxHeight,
            min: borderValues.minHeight,
            pattern: '[0-9]',
          }}
          required
          error={errors.amsl_min}
          fullWidth
          type="number"
          id="amsl_min"
          name="amsl_min"
          autoComplete="amsl_min"
          onChange={handleChange}
          value={values.amsl_min}
          helperText={
            errors.amsl_min &&
            `${helperTextForm('number')}, min. ${
              borderValues.minHeight
            }, max. ${borderValues.maxHeight}`
          }
          size="small"
          InputProps={{
            endAdornment: endAdornmentProps('[ft.]'),
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          FormHelperTextProps={{
            classes: {
              error: `${formClasses.Form}__text-field__form-helper--error`,
            },
          }}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <label
          className={clsx(`${formClasses.Form}__label`, {
            [`${formClasses.Form}__text-field__form-helper--error`]: errors.amsl_max,
          })}
          htmlFor="amsl_max"
        >
          {strings.formFields.max_} *
        </label>
        <TextField
          variant="outlined"
          required
          inputProps={{
            placeholder: `${strings.formFields.max_}, max. ${borderValues.maxHeight}`,
            max: borderValues.maxHeight,
            min: borderValues.minHeight,
            pattern: '[0-9]',
          }}
          error={errors.amsl_max}
          fullWidth
          id="amsl_max"
          type="number"
          name="amsl_max"
          autoComplete="amsl_max"
          onChange={handleChange}
          value={values.amsl_max}
          helperText={
            errors.amsl_max &&
            `${helperTextForm('number')}, min. ${
              borderValues.minHeight
            }, max. ${borderValues.maxHeight}`
          }
          size="small"
          InputProps={{
            endAdornment: endAdornmentProps('[ft.]'),
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          FormHelperTextProps={{
            classes: {
              error: `${formClasses.Form}__text-field__form-helper--error`,
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <label
          className={clsx(`${formClasses.Form}__label`, {
            [`${formClasses.Form}__text-field__form-helper--error`]: errors.contact,
          })}
          htmlFor="contact"
        >
          {strings.formFields.contact_} *
        </label>
        <TextField
          variant="outlined"
          required
          error={errors.contact}
          inputProps={{
            placeholder: placeholderForm.phonePattern,
            pattern: '[0-9]{9}',
          }}
          fullWidth
          id="contact"
          type="tel"
          name="contact"
          autoComplete="contact"
          onChange={handleChange}
          value={values.contact}
          helperText={errors.contact && helperTextForm('phone')}
          size="small"
          InputProps={{
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          FormHelperTextProps={{
            classes: {
              error: `${formClasses.Form}__text-field__form-helper--error`,
            },
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <label
          className={clsx(`${formClasses.Form}__label`, {
            [`${formClasses.Form}__text-field__form-helper--error`]: errors.description,
          })}
          htmlFor="description"
        >
          {strings.formFields.desc_} *
        </label>
        <TextField
          margin="dense"
          variant="outlined"
          required
          inputProps={{
            placeholder: strings.formFields.desc_ + placeholderForm.description,
            maxLength: 250,
          }}
          error={errors.description}
          fullWidth
          id="description"
          type="text"
          multiline
          rows="6"
          name="description"
          autoComplete="description"
          onChange={handleChange}
          value={values.description}
          helperText={errors.description && helperTextForm('desc')}
          size="small"
          InputProps={{
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          FormHelperTextProps={{
            classes: {
              error: `${formClasses.Form}__text-field__form-helper--error`,
            },
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <FormControl component="fieldset">
          <label className={`${formClasses.Form}__label`} htmlFor="visibility">
            {strings.formFields.visibility_}
          </label>
          <RadioGroup
            aria-label="visibility"
            name="visibility"
            value={values.visibility}
            className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--width`}
            onChange={handleChange}
          >
            <Grid container>
              <Grid item xs={6}>
                <FormControlLabel
                  value="public"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={strings.formFields.public_}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  value="private"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={strings.formFields.private_}
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <label className={`${formClasses.Form}__label`} htmlFor="description">
          {strings.formFields.type_}: SRTM
        </label>

        <Switch
          classes={{
            checked: `${formClasses.Form}__switch`,
            track: `${formClasses.Form}__switch__track`,
          }}
          checked={switchIsActiveChecked}
          onChange={handleSwitchIsActiveChange}
        />
        <span className={`${formClasses.Form}__label`} htmlFor="description">
          NMT (dev)
        </span>
      </Grid>
      {/* dev */}
      <Grid item xs={12}>
        <Button
          type="button"
          fullWidth
          onClick={save}
          className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
        >
          {strings.formFields.button_}
        </Button>
      </Grid>
      <RequiredField />
    </Grid>
  );
};

ZoneDetailsForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  borderValues: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
    .isRequired,
};

export default ZoneDetailsForm;
